import axios from 'axios'
import * as types from '../mutation-types'
// import * as acts from '../actions'

const state = {
  reports: [],
  guestVisits: [],
  ready: false,
  currentReport: null,
  operators: [],
}

// getters
const getters = {
  reports: state => state.reports,
  guestVisits: state => state.guestVisits,
  ready: state => state.ready,
  currentReport: state => state.currentReport,
}

// actions
const actions = {
  async setCurrentReport ({commit, dispatch, rootState}, report) {
    let resp = await axios.get('/api/reports/', {params: {'operator': rootState.dicts.currentOperator.id}})
    await commit(types.MUTATE_REPORTS, resp.data)
    commit(types.MUTATE_CURRENT_REPORT, report)
    dispatch('getGuestVisits', {
      params: {'report': report, 'operator': rootState.dicts.currentOperator.id}
    })
  },
  async getGuestVisits ({commit, rootState}, params) {
    commit(types.FETCH_START)
    let resp = await axios.get('/api/guest_visits/',
      {
        params: {
          'operator': rootState.dicts.currentOperator.id,
          'report': state.currentReport ? state.currentReport.id : ''
        }
      })
    commit(types.MUTATE_GUEST_VISITS, resp.data)

    return commit(types.FETCH_END)
  },
  async getReports ({commit, rootState, dispatch}, params) {
    commit(types.FETCH_START)
    let resp = await axios.get('/api/reports/', {params: {'operator': rootState.dicts.currentOperator.id}})
    commit(types.MUTATE_REPORTS, resp.data)
    await dispatch('getGuestVisits', {
      params: {
        'report': state.currentReport ? state.currentReport.id : '',
        'operator': rootState.dicts.currentOperator.id
      }
    })
    return commit(types.FETCH_END)
  }
  /*getGuestVisits ({commit}, params) {
    commit(types.FETCH_START)
    return axios.get('/api/guest_visits/', params).then(res => {
      commit(types.MUTATE_GUEST_VISITS, res.data)
      commit(types.FETCH_END)
    })
  },*/
}

// mutations
const mutations = {
  [types.FETCH_START] (state) {
    state.ready = false
  },
  [types.MUTATE_REPORTS] (state, reports) {
    state.reports = reports
    // If current report not from current operator - change to first available report
    if (reports.length === 0) {
      state.currentReport = null
    } else if (!state.currentReport || state.currentReport.operator !== reports[0].operator) {
      state.currentReport = reports[0]
    }
  },
  [types.MUTATE_CURRENT_REPORT] (state, report) {
    if (state.reports.length > 0) {
      state.currentReport = state.reports.find(item => Number(item.id) === Number(report))
    }
  },
  [types.MUTATE_GUEST_VISITS] (state, res) {
    state.guestVisits = res
  },
  [types.FETCH_END] (state) {
    state.ready = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/guest-visits.js